export default __webpack_public_path__ + "static/media/meet.86378491.svg";